import axios from "axios";

export const refrescarCatalogoInsumosCliente = async ({ empresaId, clienteId, usarPrecioCliente, insumos, todasInsumos, headersToken }) => {
  const ids = [
    ...new Set((insumos || []).map((fila) => fila?.insumoId?._id || fila?.insumoId).filter(Boolean).map(String)),
  ];
  if (ids.length === 0) return todasInsumos;
  const res = await axios.post(
    "insumos/catalogoInsumosVentaCliente",
    { empresaId, clienteId, insumosIds: ids, usarPrecioCliente },
    { headers: headersToken }
  );
  if (res.data?.success !== 2) return todasInsumos;
  const nuevos = new Map(res.data.insumos.map((insumo) => [String(insumo._id), insumo]));
  return (todasInsumos || []).map((insumo) => {
    const nuevo = nuevos.get(String(insumo._id));
    if (!nuevo) return insumo;
    return {
      ...insumo,
      nombreClienteAlternativo: undefined,
      claveClienteAlternativa: undefined,
      precioClienteAlternativo: undefined,
      presentacionCliente: undefined,
      ...nuevo,
    };
  });
};
